export default {
  'auth.login_title': '로그인',
  'auth.login_subtitle': 'QR 코드 로그인 시스템',
  'auth.email_label': '이메일',
  'auth.password_label': '비밀번호',
  'auth.logging_in': '로그인 중...',
  'auth.login_button': '로그인',
  'auth.no_account': '계정이 없으신가요?',
  'auth.signup_link': '회원가입',
  'auth.generate_qr_on_pc': 'PC에서 QR 생성하기',
  'auth.login_failed': '로그인에 실패했습니다.',

  'auth.signup_title': '회원가입',
  'auth.signup_subtitle': '새 계정을 만들어보세요',
  'auth.confirm_password_label': '비밀번호 확인',
  'auth.password_placeholder': '최소 6자 이상',
  'auth.confirm_password_placeholder': '비밀번호를 다시 입력하세요',
  'auth.signing_up': '가입 중...',
  'auth.signup_button': '회원가입',
  'auth.has_account': '이미 계정이 있으신가요?',
  'auth.login_link': '로그인',
  'auth.signup_success': '회원가입이 완료되었습니다! 로그인 페이지로 이동합니다...',
  'auth.password_mismatch': '비밀번호가 일치하지 않습니다.',
  'auth.password_too_short': '비밀번호는 최소 6자 이상이어야 합니다.',
  'auth.signup_failed': '회원가입에 실패했습니다.',

  'auth.email_placeholder': 'your@email.com',
};
